// The tinted initials badge for a firm. Colours come from gaTone, which is
// plain TypeScript so it can be tested: the test runner only picks up .ts.

import { cn } from "@/lib/utils";
import { toneFor, initialsOf } from "./gaTone";

/** The square initials badge. `id` decides the colour, so pass the firm's id. */
export function GaMark({
  id,
  name,
  className,
}: {
  id: number;
  name: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-lg font-bold",
        toneFor(id).mark,
        className ?? "h-7 w-7 text-[10px]",
      )}
    >
      {initialsOf(name)}
    </span>
  );
}
